import {useContext} from 'react'
import {OrderReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {ORDER_REPORT_COLUMNS} from '../../utils'
import OrderReportTableRow from './OrderReportTableRow'

const OrderReportTable = () => {
  const {ordersReportData, isOrdersReportLoading, filters, onSortingChange} =
    useContext(OrderReportContext)

  return (
    <div className='sticky-table-wrapper'>
      <div className='table-responsive-wrapper'>
        <div className='table-responsive'>
          <DynamicTable
            data={ordersReportData}
            sortableColumns={ORDER_REPORT_COLUMNS}
            loading={isOrdersReportLoading}
            TableRow={OrderReportTableRow}
            noDataMessage='No order records found'
            tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
            tableHeaderClass='sticky-table-header'
            filters={filters}
            onSortingChange={onSortingChange}
          />
        </div>
      </div>
    </div>
  )
}

export default OrderReportTable
